import $ from 'jquery';

export default function RentalAgreementViewModel() {

    $('footer').addClass('no-print');
    $('header').addClass('no-print');

    return this;
}